import { createUUID } from "../../Misc";
export class AThing {
    constructor(filename) {
        this.type = "thing";
        this.folder = null;
        this.key = null;
        this.filename = null;
        this.display = null;
        this.filename = filename;
        this.key = createUUID();
    }
    path() {
        let p = [];
        var a = this;
        while (a && a.folder) {
            p.push(a.filename);
            a = a.folder;
        }
        return p.reverse();
    }
    fixFolders() {
        if (this.folder) {
            let temp = new AFolder("");
            this.folder = Object.assign(temp, this.folder);
            this.folder.fixFolders();
        }
    }
    equal(a) {
        return (this.filename == a.filename) && (this.type == a.type);
        // && (
        //   this.folder == a.folder
        // )
    }
}
export class ABook extends AThing {
    constructor(filename, dxf, svg, info) {
        super(filename);
        this.type = "file";
        this.dxf = null;
        this.svg = null;
        this.notes = "";
        this.display = "";
        this.info = null;
        this.dxf = dxf;
        this.svg = svg;
        this.display = info ? info.filename : filename;
        // info && (this.notes = info.notes);
        if (info) {
            this.notes = info.notes;
            this.info = info;
        }
    }
}
export class AFolder extends AThing {
    constructor() {
        super(...arguments);
        this.type = "folder";
    }
    addChildren(keys) {
        return keys.forEach((element) => {
            if (element)
                //sometimes an element is null
                element.folder = this;
        });
    }
    isParent(key) {
        if (this.key == key)
            return true;
        return this.folder && this.folder.isParent(key);
    }
}
